<mat-card class="mat-elevation-z4">
  <mat-card-title>Login</mat-card-title>
  <mat-card-subtitle>Please log in to access the app.</mat-card-subtitle>
  <mat-card-content>
    <form [formGroup]="loginForm" (ngSubmit)="submit()">
      <mat-form-field appearance="standard">
        <mat-label>Email</mat-label>
        <input
          matInput
          placeholder="Email"
          type="text"
          formControlName="email"
        />
        <mat-icon matSuffix>person</mat-icon>
        <!-- <mat-hint>Hint</mat-hint> -->
      </mat-form-field>

      <mat-form-field appearance="standard">
        <mat-label>Password</mat-label>
        <input
          matInput
          placeholder="Password"
          [type]="hiddenPassword ? 'password' : 'text'"
          formControlName="password"
        />
        <mat-icon matSuffix (click)="hiddenPassword = !hiddenPassword">{{
          hiddenPassword ? 'visibility_off' : 'visibility'
        }}</mat-icon>
        <!-- <mat-icon matSuffix>sentiment_very_satisfied</mat-icon> -->
        <!-- <mat-hint>Hint</mat-hint> -->
      </mat-form-field>
      <div id="actions">
        <button mat-raised-button color="primary">Login</button>
      </div>
    </form>
  </mat-card-content>
  <!-- <img mat-card-image> -->
  <mat-card-actions>
    <!-- <button mat-raised-button>Cancel</button> -->
  </mat-card-actions>
  <mat-card-footer></mat-card-footer>
</mat-card>
